import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import LogoIcon from "../LogoIcon";

export default function Loading(props) {
  return (
    <Box sx={{ position: "relative" }} {...props}>
      <CircularProgress
        sx={{
          position: "absolute",
          left: -7,
          top: -7,
        }}
        size={114}
      />
      <LogoIcon
        sx={{
          width: 100,
          height: 100,
          position: "relative",
          verticalAlign: "top",
        }}
      />
    </Box>
  );
}
